import { createCrudSlice } from "./createCrudSlice";
import {
  GET_CUSTOMERS,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_VEHICLE_DETAILS,
  GET_CUSTOMER_TRANSACTIONS,
  GET_CUSTOMER_MEMBERSHIPS,
  UPDATE_CUSTOMER_STATUS,
  GET_CUSTOMERS_LIST,
} from "helpers/url_helper";

const { reducer, actions, thunks } = createCrudSlice({
  name: "customers",

  urls: {
    getList: GET_CUSTOMERS,
    getDetails: GET_CUSTOMER_DETAILS,
    updateStatus: UPDATE_CUSTOMER_STATUS,
  },

  initialFilters: {
    keyword: "",
    status: -1,
    orderBy: -1,
    dates: [],
    pageNo: 1,
    perPage: 50,
    platform :""
  },

  additionalThunks: {
    getVehicleDetails: {
      type: "customers/getVehicleDetails",
      url: (customerId) => `${GET_CUSTOMER_VEHICLE_DETAILS}/${customerId}`,
      method: "get",
      stateKey: "vehicleDetails",
      loadingKey: "loading2",
    },
    getTransactions: {
      type: "customers/getTransactions",
      url: (customerId) => `${GET_CUSTOMER_TRANSACTIONS}/${customerId}`,
      method: "get",
      stateKey: "transactions",
      loadingKey: "loading2",
    },
    getMemberships: {
      type: "customers/getMemberships",
      url: (customerId) => `${GET_CUSTOMER_MEMBERSHIPS}/${customerId}`,
      method: "get",
      stateKey: "memberships",
      loadingKey: "loading2",
    },
    getCustomersList: {
      type: "customers/getCustomerDropdownList",
      url: (keyword) => `${GET_CUSTOMERS_LIST}?keyword=${keyword}`,
      method: "get",
      stateKey: "customersList",
    },
  },

  initialState: {
    loading2: true,
    vehicleDetails: [],
    transactions: [],
    memberships: [],
    customersList: [],
  },
});

// Export actions
export const { setFilter, resetFilters, clearItemDetails } = actions;

// Export thunks
export const {
  getList: getCustomers,
  getDetails: getCustomerDetails,
  updateStatus: updateCustomerStatus,
  getVehicleDetails,
  getTransactions,
  getMemberships,
  getCustomersList,
} = thunks;

// Export reducer
export default reducer;
